import { ActivityDetailModalProps } from "@presenter";
import { Modal, PrimaryDataTable, TableColumn, TableRow } from "@component";
import React from "react";
import { getContentType } from "@util";

const UserTendencyCategoryModal = ({ data, isLoading, types }: ActivityDetailModalProps) => {
  return (
    <Modal width={"80%"} modalKey={"modalCategory"} title={"사용자 카테고리 성향 상세"} footer={false}>
      <PrimaryDataTable headers={["카테고리", "점수", "최고 점수 대비 백분율"]} isLoading={isLoading} useFilter={false} pagination={false}>
        {
          data ? data.categoryList?.map((item: any, index: number) => {
            const { key, score } = item;
            const percentage = score / data.categoryList[0].score * 100
            return (
              <TableRow
                key={index}
                enableDetailButton={true}
                enableOverlay={false}
                onClickDetailButton={() => {}}>
                <TableColumn align={"center"}>{ getContentType(key, types) }</TableColumn>
                <TableColumn align={"center"}>{ score }점</TableColumn>
                <TableColumn align={"center"} percentage={percentage}>{ percentage.toFixed(1) }%</TableColumn>
              </TableRow>
            )
          }) : <></>
        }
      </PrimaryDataTable>
    </Modal>
  )
}

export default UserTendencyCategoryModal
